// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

body {
  background: #ccc url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  background-attachment: fixed;
  font-family: "Inconsolata", SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-weight: 300;
  font-size: 18px;
  line-height: 1.9;
  color: #6c757d;
}

::selection {
  color: white;
  background: #6D0000;
}

a {
  transition: .3s all ease;
  text-decoration: none;
  color: #6d0000;  }
  a:hover {
    /*text-decoration: none;*/
    color: #1d0000; }

a, button, input {
  transition: all 0.3s ease;
}
  

h1, h2, h3, h4, h5 {
  color: #000;
}

.wrap {
  max-width: 1450px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.8); 
}

header {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  font-weight: 400;
  background: #fff !important; }
  header .navbar-brand {
    text-transform: uppercase;
    letter-spacing: .2em;
    font-weight: 400;
    color: #fff !important; }
  header .navbar-collapse {
    position: relative; }
  header .navbar {
    padding-top: 0;
    padding-bottom: 0;
    background: transparent !important; }
    header .navbar .navbar-nav.absolute-right {
      position: absolute;
      right: 0; }
      @media (max-width: 991.98px) {
        header .navbar .navbar-nav.absolute-right {
          position: relative;
          right: inherit; } }
    header .navbar .nav-link {
      padding: 1.7rem 1rem;
      font-size: 16px;
      outline: none !important;
      text-transform: uppercase;
      letter-spacing: .05em; }
      @media (max-width: 991.98px) {
        header .navbar .nav-link {
          padding: 1.7rem 1rem; } }
      @media (max-width: 767.98px) {
        header .navbar .nav-link {
          padding: .5rem 0rem; } }
    header .navbar .dropdown-menu {
      font-size: 14px;
      border-radius: 0px;
      border: none;
      box-shadow: 0 2px 30px 0px rgba(0, 0, 0, 0.2);
      min-width: 13em;
      margin-top: -10px; }
      header .navbar .dropdown-menu:before {
        bottom: 100%;
        left: 10%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-bottom-color: #fff;
        border-width: 10px; }
        @media (max-width: 1199.98px) {
          header .navbar .dropdown-menu:before {
            display: none; } }
      header .navbar .dropdown-menu .dropdown-item:hover {
        background: #000;
        color: #fff; }
      header .navbar .dropdown-menu .dropdown-item.active {
        background: #000;
        color: #fff; }
      header .navbar .dropdown-menu a {
        padding-top: 7px;
        padding-bottom: 7px; }

.absolute-toggle {
  position: absolute;
  left: 15px;
  top: 5px; }
  .absolute-toggle .burger-lines {
    width: 30px;
    display: inline-block;
    height: 2px;
    background: #000;
    position: relative; }
    .absolute-toggle .burger-lines:before, .absolute-toggle .burger-lines:after {
      position: absolute;
      height: 2px;
      content: "";
      background: #000;
      width: 100%;
      left: 0; }
    .absolute-toggle .burger-lines:before {
      top: -10px; }
    .absolute-toggle .burger-lines:after {
      bottom: -10px; }

.site-logo a {
  color: #000;
  font-size: 48px; 
}
@media (max-width: 767.98px) {
    .site-logo a {
        font-size: 34px;
    }
}

.top-bar {
  background: #000;
  padding: 10px 0;
}
  .top-bar .social a, .top-bar .search-icon a {
    color: #fff;
    opacity: .5;
    padding: 5px; }
    .top-bar .social a:hover, .top-bar .search-icon a:hover {
      opacity: 1; }
  .top-bar .social {
    text-align: left;
    margin-top: 0.2em	}
  .top-bar .search-icon {
    text-align: right; }

@media (max-width: 575.98px) {
    .social {
    text-align:center !important; }
    .social a {
    margin-left:0.5em;
    margin-right:0.5em;	} 
}	
@media (min-width: 576px) and (max-width: 991.98px) {
    .social {
    text-align:center !important; }
    .social a {
    margin-left:1.5em;
    margin-right:1.5em;	} 
}
    
.navbar .container
  @media (max-width: 767.98px) {
    .navbar .container > div {
      border-bottom: none; } }

.bio img {
    border: 2px solid #fff;
    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.4);
    max-width: 100px;
    /*border-radius: 50%;*/
    position: relative;
    margin-bottom: 30px;
}

.site-section {
  padding: 1em 0; }
  .site-section.py-md {
    padding: 0em 0; }
  .site-section.py-sm {
    padding: 0em 0; }

.trades-text {
    color: #888;
}
.trades-id {
    position: absolute;
    font-size: 11px;
    right: 25px;
    bottom: 25px; 	
}
.trades-entry {
  display: block;
  transition: .3s all ease;
  position: relative;
  margin-bottom: 20px;
  padding: 0px 20px 20px 20px;
  border: 1px solid #efefef;
}
  .trades-entry:hover, .trades-entry:focus {
    opacity: .9;
    /*-webkit-box-shadow: 0 3px 50px -2px rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0 3px 50px -2px rgba(0, 0, 0, 0.2) !important; */
    box-shadow: 5px 10px black;}
  .trades-entry h2 {
    font-size: 18px;
    line-height: 1.5; }
  .trades-entry p {
    font-size: 13px;
    color: gray; }
.trades-title {
    color: black;
    font-size: 1.3rem !important;
    display: inline;
}
.trades-img {
    height: 2rem;
    display: inline;
    margin-bottom: 0.5rem;
    padding-right: 0.5rem;
}
.trades-content-body {
    background-position: right 1rem top 3rem !important;
}

.post-meta {
  font-size: 14px;
  color: #888; }
  .trades-entries .post-meta .author img {
    width: 30px;
    border-radius: 50%;
    display: inline-block; }
.stats-post-meta {
    display: inline;
    font-size: 14px;
    color: #888;
    margin-left: 2rem;	
}
    
.closed_green {
  font-size: 18px;
  color: #4bb820;
  float: right;  }
.closed_red {
  font-size: 18px;
  color: #b82020;
  float: right;  }
.open_position {
  font-size: 18px;
  color: #888;
  float: right;  }
.stats_green {
  color: #4bb820;
}
.stats_red {
  color: #b82020;
}

.flaticon-custom {
  font-size: 70px; }
  .flaticon-custom:before, .flaticon-custom:after {
    margin-left: 0; }

.no-nav .owl-nav {
  display: none; }

blockquote {
  padding-left: 30px;
  border-left: 10px solid #e6e6e6; }
  blockquote p {
    font-size: 18px;
    font-style: italic;
    color: #000; }

.list-unstyled.check li {
  position: relative;
  padding-left: 30px;
  line-height: 1.3;
  margin-bottom: 10px; }
  .list-unstyled.check li:before {
    color: #17a2b8;
    left: 0;
    font-family: "Ionicons";
    content: "\\f122";
    position: absolute; }

#modalAppointment .modal-content {
  border-radius: 0;
  border: none; }

#modalAppointment .modal-body, #modalAppointment .modal-footer {
  padding: 40px; }

.overflow {
  position: relative;
  overflow-x: hidden; }

.site-footer {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 1em 0;
  background: #000; }
  .site-footer .post-entry-sidebar ul li a h4 {
    color: #fff; }
  .site-footer .footer-social li a > span {
    width: 30px; }
  .site-footer a {
    color: #fff; }
    .site-footer a:hover {
      opacity: .5; }
  .site-footer h3 {
    color: #fff;
    margin-bottom: 30px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: .2em; }
  .site-footer p {
    color: rgba(255, 255, 255, 0.5); }

.analysis-entry-footer .post-meta {
  color: white;
  font-size: 15px; }

.border-t {
  border-top: 1px solid #f8f9fa; }

.copyright {
  font-size: 14px; }

.element-animate {
  opacity: 0;
  visibility: hidden; }
  
#loader {
  position: fixed;
  width: 96px;
  height: 96px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 24px 64px rgba(0, 0, 0, 0.24);
  border-radius: 16px;
  opacity: 0;
  visibility: hidden;
  transition: opacity .2s ease-out, visibility 0s linear .2s;
  z-index: 1000;
}

#loader.fullscreen {
  padding: 0;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: none;
  background-color: #fff;
  border-radius: 0;
  box-shadow: none;
}

#loader.show {
  transition: opacity .4s ease-out, visibility 0s linear 0s;
  visibility: visible;
  opacity: 1;
}

#loader .circular {
  animation: loader-rotate 2s linear infinite;
  position: absolute;
  left: calc(50% - 24px);
  top: calc(50% - 24px);
  display: block;
  transform: rotate(0deg);
}

#loader .path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: loader-dash 1.5s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes loader-rotate {
  100% {
    transform: rotate(360deg); }
}

@keyframes loader-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0; }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px; }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -136px; }
}

@keyframes loader-rotate {
  100% {
    transform: rotate(360deg); } }

@keyframes loader-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0; }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px; }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -136px; } }
    
.login {
    width: 400px;
    background-color: #ffffff;
      box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
      margin: 0px auto;
}
@media (max-width: 767.98px) {
      .login {
        width: 90%;
      }
  }
  
.login h1 {
      text-align: center;
      color: #5b6574;
      font-size: 24px;
      padding: 20px 0 20px 0;
      border-bottom: 1px solid #dee0e4;
}
.login form {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 20px;
}
.login form label {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background-color: #000;
      color: #ffffff;
}
@media (max-width: 767.98px) {
      .login form label {
        width: 90%;
      }
  }

.login form input[type="password"], .login form input[type="text"] {
      width: 310px;
      height: 50px;
      border: 1px solid #dee0e4;
      margin-bottom: 20px;
      padding: 0 15px;
}
@media (max-width: 767.98px) {
      .login form input[type="password"], .login form input[type="text"] {
        width: 90%;
      }
  }

.login form input[type="submit"] {
      width: 100%;
      padding: 15px;
     margin-top: 20px;
      background-color: #000;
      border: 0;
      cursor: pointer;
      font-weight: bold;
      color: #ffffff;
      transition: background-color 0.2s;
    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
}
.login form input[type="submit"]:hover {
    background-color: #ffffff;
    color: #000;
      transition: background-color 0.2s;
    border-inline: 1px solid black;
}

.logout {
    width: 200px;
    background-color: #ffffff;
      box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
      margin: 0px auto;
}
@media (max-width: 767.98px) {
      .logout {
        width: 90%;
      }
  }
  
.logout h1 {
      text-align: center;
      color: #5b6574;
      font-size: 24px;
      padding: 20px 0 20px 0;
      border-bottom: 1px solid #dee0e4;
}
.logout form {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
}
.logout form label {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background-color: #000;
      color: #ffffff;
}
@media (max-width: 767.98px) {
      .logout form label {
        width: 90%;
      }
  }

.logout form input[type="submit"] {
      width: 100%;
      padding: 15px;
      background-color: #000;
      border: 0;
      cursor: pointer;
      font-weight: bold;
      color: #ffffff;
      transition: background-color 0.2s;
    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
}
.logout form input[type="submit"]:hover {
    background-color: #ffffff;
    color: #000;
      transition: background-color 0.2s;
    border-inline: 1px solid black;
}

form input, form button {
    width: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;	
}
.social_post {
    width: 50% !important;
    float:left;
}
.trade_post {
    width: 33% !important;
    float:left;
}

.seperate {
    width: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;	
}
.seperate-save {
    width: 100%;
    background-color: #000;
    padding: 5px;
      border: 1px solid black;
      cursor: pointer;
      font-weight: bold;
      color: #ffffff;
    border-inline: 1px solid black;
}
.seperate-save:hover {
    background-color: #ffffff;
    color: #000;
      transition: background-color 0.2s;
}
.seperate-mid {
    width: 50%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    float: left;
}
.seperate-short {
    width: 33%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    float: left;
}
.seperate-longtext {
    width: inherit;
    box-sizing: border-box;
    -moz-box-sizing: border-box;	
}
.save, .delete, .update {
    width: 100%;
    background-color: #000;
    padding: 5px;
      border: 1px solid black;
      cursor: pointer;
      font-weight: bold;
      color: #ffffff;
}
.save:hover, .delete:hover, .update:hover {
    background-color: #ffffff;
    color: #000;
      transition: background-color 0.2s;
    border-inline: 1px solid black;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #ddd;
}
th, td {
    text-align: left;
    padding: 5px;
}
tr:nth-child(even){background-color: #f2f2f2}
.marketcap tr:nth-child(even) {background-color: white !Important;}

.marketcap {
    font-size: 16px;
}

.chart-container {
    width: 100%;
    height: auto;
}
.pie-chart-container {
    width: 360px;
    height: 360px;
    float: left;
}

.archive {
    margin-left: auto !important;
    margin-right: auto !important;
}
.archive_sitenr {
    padding-right: 2rem;
    padding-left: 2rem;
}

.archive_sitenr:hover {
  background-color: #fff;
  color: #000;
  transition: background-color 0.2s;
}

.cryptoslider-box {
    height:40px !important; 
    background-color: #FFFFFF !important; 
    border-radius: 4px; 
}

.cryptoslider {
    overflow: hidden;
    white-space: nowrap;
    position: relative;
}

.cryptoslider img {
    height: 25px;
}

.cryptoslide-unit {
     /* Starting position */
     transform:translateX(100%);
     /* Apply animation to this element */
     animation: scroll 50s linear infinite;
}

/* Move it (define the animation) */
@keyframes scroll {
 0%   { /* Firefox bug fix */ /* Firefox bug fix */
 transform: translateX(100%); 
 }
 100% { /* Firefox bug fix */ /* Firefox bug fix */
 transform: translateX(calc(-210px * 15)); 
 }
}

.cryptoslide:hover,
.cryptoslide-unit:hover,
.cryptoslider:hover,
.cryptoslider-box:hover {
    animation-play-state: paused
}

.cryptoslider h5 {
    margin-top: 0.35em;
}

.cryptoslider object {
    width: 15px;
    height: 15px;
}

#searchbar, #searchbar_trade, #searchbar_analysis {
    width: 100%;
}

input#searchbar, input#searchbar_trade, input#searchbar_analysis {
    width: 100%;
}

.crypto-right {
    text-align: right;
}
.crypto-logo-left {
    float: left;
    margin: 10px 25px 10px 0px;
    width: 100px;
    position: relative;
} @media (max-width: 767.98px) {
  .crypto-logo-left {
    width: 60px; } }
.crypto-logo-right {
    float: right;
    margin: 10px 0px 10px 25px;
    width: 100px;
    position: relative;
} @media (max-width: 767.98px) {
  .crypto-logo-right {
    width: 60px; } }
.crypto-logo-left:hover, .crypto-logo-left:focus, .crypto-logo-right:hover, .crypto-logo-right:focus {
    opacity: .9;
    top: -1px;
    box-shadow: 0 3px 50px -2px rgba(255, 252, 255, 0.2) !important; 
}

.investment-logo {
    transition: .3s all ease;
    float: left;
    margin: 10px 10px;
    width: 140px;
    position: relative;
} @media (max-width: 767.98px) {
  .investment-logo {
    width: 60px; } }
  .investment-logo:hover, .investment-logo:focus {
    opacity: .9;
    top: -1px;
    box-shadow: 0 3px 50px -2px rgba(255, 252, 255, 0.2) !important; }
    
.popover {
    max-width: 100%;
}

.form-control:focus {
    border-color: black;
    box-shadow: 0 0 0 .2rem rgba(0,0,0,.25);
}

.token_market {
    overflow-x: auto;
    opacity: 1;
    animation: fade 2s linear;
} @keyframes fade {
  0% { opacity: 0 }
  100% { opacity: 1 }
}

.trade {
      padding: 15px;
     margin-top: 10px;
      border: 0;
      cursor: pointer;
      font-weight: bold;
      transition: background-color 0.2s;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
}
.trade:hover {
    background-color: #000;
    color: #fff;
      transition: background-color 0.2s;
}

.mobile_table {
    overflow-x: auto;
}
.mobile_table img {
    height: 40px;
}
@media (max-width: 575.98px) {
    .mobile_table {
        font-size: 10px !important;
    }
    .mobile_table img {
        height: 20px;
    }
    .mobile_table th, .mobile_table td {
        padding: 1px !important;
    }
}
@media (min-width: 576px) and (max-width: 991.98px) {
    .mobile_table {
        font-size: 14px !important;
    }
    .mobile_table img {
        height: 30px;
    }
}

.btn:focus {
    outline: none !important;
}

@media (max-width: 767.98px) {
    .token_contract {
        font-size: 15px;
    }
}

 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-flex;
  width: 30px;
  height: 17px;
  bottom: 2px
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #6d0000;
}

input:focus + .slider {
  box-shadow: 0 0 1px #6d0000;
}

input:checked + .slider:before {
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

#sideshift-modal-button {
  -webkit-appearance: none;
  background: #1f1f1f;
  color: #fff;
  cursor: pointer;
  border: 0;
  margin: 0 auto 1rem auto;
  min-width: 10rem;
  position: relative;
  z-index: 2;
  font-weight: bold;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
}

#sideshift-modal-button:hover {
  background-color: #fff;
  color: #000;
  transition: background-color 0.2s;
}

.gobackhome {
    overflow: hidden;
    padding: 10px 3px;

}

.qr {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.crop {
    overflow: hidden;
    white-space: nowrap;
}

#scrollbacktop {
  -webkit-appearance: none;
  background: #fff;
  color: #000;
  cursor: pointer;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  border: none;
  outline: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}

#scrollbacktop:hover {
  background-color: #1f1f1f;
  color: #fff;
  transition: background-color 0.2s;
}

.qr-container {
  background: white;
  padding: 15px;
  border-radius: 4px;
}

.popover {
  max-width: 300px;
}

.qr-wrapper svg {
  display: block;
}

.btn-link.qr {
  color: inherit;
}

.btn-link.qr:hover {
  opacity: 0.8;
}

@media (max-width: 767.98px) {
  body {
    font-size: 14px;
    line-height: 1.7;
  }
  
  .trades-title {
    font-size: 1.1rem !important;
  }
  
  .trades-text, .post-meta {
    font-size: 12px;
  }
  
  .closed_green, .closed_red, .open_position {
    font-size: 16px;
  }
  
  .trades-id {
    font-size: 10px;
  }
  
  blockquote p {
    font-size: 14px;
  }
  
  .marketcap {
    font-size: 14px;
  }
  
  .cryptoslider h5 {
    font-size: 14px;
    margin-top: 0.25em;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,sFAA8E;EAI9E,sBAAsB;EACtB,4BAA4B;EAC5B,gHAAgH;EAChH,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAMA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EAGE,wBAAwB;EACxB,qBAAqB;EACrB,cAAc,GAAG;EACjB;IACE,yBAAyB;IACzB,cAAc,EAAE;;AAEpB;EACE,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAEhB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,2BAA2B,EAAE;EAC7B;IACE,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB,EAAE;EAC1B;IACE,kBAAkB,EAAE;EACtB;IACE,cAAc;IACd,iBAAiB;IACjB,kCAAkC,EAAE;IACpC;MACE,kBAAkB;MAClB,QAAQ,EAAE;MACV;QACE;UACE,kBAAkB;UAClB,cAAc,EAAE,EAAE;IACxB;MACE,oBAAoB;MACpB,eAAe;MACf,wBAAwB;MACxB,yBAAyB;MACzB,qBAAqB,EAAE;MACvB;QACE;UACE,oBAAoB,EAAE,EAAE;MAC5B;QACE;UACE,mBAAmB,EAAE,EAAE;IAC7B;MACE,eAAe;MACf,kBAAkB;MAClB,YAAY;MAEZ,6CAA6C;MAC7C,eAAe;MACf,iBAAiB,EAAE;MACnB;QACE,YAAY;QACZ,SAAS;QACT,yBAAyB;QACzB,YAAY;QACZ,SAAS;QACT,QAAQ;QACR,kBAAkB;QAClB,oBAAoB;QACpB,yBAAyB;QACzB,kBAAkB,EAAE;QACpB;UACE;YACE,aAAa,EAAE,EAAE;MACvB;QACE,gBAAgB;QAChB,WAAW,EAAE;MACf;QACE,gBAAgB;QAChB,WAAW,EAAE;MACf;QACE,gBAAgB;QAChB,mBAAmB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAE;EACV;IACE,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAE;IACpB;MACE,kBAAkB;MAClB,WAAW;MACX,WAAW;MACX,gBAAgB;MAChB,WAAW;MACX,OAAO,EAAE;IACX;MACE,UAAU,EAAE;IACd;MACE,aAAa,EAAE;;AAErB;EACE,WAAW;EACX,eAAe;AACjB;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;EACE;IACE,WAAW;IACX,WAAW;IACX,YAAY,EAAE;IACd;MACE,UAAU,EAAE;EAChB;IACE,gBAAgB;IAChB,kBAAkB;EACpB;IACE,iBAAiB,EAAE;;AAEvB;IACI;IACA,4BAA4B,EAAE;IAC9B;IACA,iBAAiB;IACjB,kBAAkB,EAAE;AACxB;AACA;IACI;IACA,4BAA4B,EAAE;IAC9B;IACA,iBAAiB;IACjB,kBAAkB,EAAE;AACxB;;AAEA;;IAEI;MACE,mBAAmB,EAAE,EAAE;;AAE7B;IACI,sBAAsB;IAEtB,gDAAgD;IAChD,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;;AAEpB;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;AACA;EACE,cAAc;EAGd,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;EACE;IACE,WAAW;IACX;gEAC4D;IAE5D,0BAA0B,CAAC;EAC7B;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,eAAe;IACf,WAAW,EAAE;AACjB;IACI,YAAY;IACZ,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,mDAAmD;AACvD;;AAEA;EACE,eAAe;EACf,WAAW,EAAE;EACb;IACE,WAAW;IACX,kBAAkB;IAClB,qBAAqB,EAAE;AAC3B;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY,GAAG;AACjB;EACE,eAAe;EACf,cAAc;EACd,YAAY,GAAG;AACjB;EACE,eAAe;EACf,WAAW;EACX,YAAY,GAAG;AACjB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,+BAA+B,EAAE;EACjC;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE,cAAc;IACd,OAAO;IACP,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB,EAAE;;AAExB;EACE,gBAAgB;EAChB,YAAY,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,cAAc;EACd,gBAAgB,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,oBAAoB,EAAE;EACxB;IACE,+BAA+B,EAAE;;AAErC;EACE,YAAY;EACZ,eAAe,EAAE;;AAEnB;EACE,6BAA6B,EAAE;;AAEjC;EACE,eAAe,EAAE;;AAEnB;EACE,UAAU;EACV,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EAGR,gCAAgC;EAChC,0CAA0C;EAE1C,6CAA6C;EAC7C,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAGlB,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EAGZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAEhB,gBAAgB;AAClB;;AAEA;EAGE,yDAAyD;EACzD,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EAEE,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EAGd,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EAEpB,gDAAgD;EAChD,qBAAqB;AACvB;;AAQA;EACE;IAEE,yBAAyB,EAAE;AAC/B;;AAcA;EACE;IACE,wBAAwB;IACxB,oBAAoB,EAAE;EACxB;IACE,yBAAyB;IACzB,wBAAwB,EAAE;EAC5B;IACE,yBAAyB;IACzB,yBAAyB,EAAE;AAC/B;;AAOA;EACE;IAEE,yBAAyB,EAAE,EAAE;;AAajC;EACE;IACE,wBAAwB;IACxB,oBAAoB,EAAE;EACxB;IACE,yBAAyB;IACzB,wBAAwB,EAAE;EAC5B;IACE,yBAAyB;IACzB,yBAAyB,EAAE,EAAE;;AAEjC;IACI,YAAY;IACZ,yBAAyB;MACvB,wCAAwC;MACxC,gBAAgB;AACtB;AACA;MACM;QACE,UAAU;MACZ;EACJ;;AAEF;MACM,kBAAkB;MAClB,cAAc;MACd,eAAe;MACf,sBAAsB;MACtB,gCAAgC;AACtC;AACA;MACM,aAAa;MACb,eAAe;MACf,uBAAuB;MACvB,iBAAiB;AACvB;AACA;MACM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,sBAAsB;MACtB,cAAc;AACpB;AACA;MACM;QACE,UAAU;MACZ;EACJ;;AAEF;MACM,YAAY;MACZ,YAAY;MACZ,yBAAyB;MACzB,mBAAmB;MACnB,eAAe;AACrB;AACA;MACM;QACE,UAAU;MACZ;EACJ;;AAEF;MACM,WAAW;MACX,aAAa;KACd,gBAAgB;MACf,sBAAsB;MACtB,SAAS;MACT,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,iCAAiC;IACnC,wCAAwC;AAC5C;AACA;IACI,yBAAyB;IACzB,WAAW;MACT,iCAAiC;IACnC,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,yBAAyB;MACvB,wCAAwC;MACxC,gBAAgB;AACtB;AACA;MACM;QACE,UAAU;MACZ;EACJ;;AAEF;MACM,kBAAkB;MAClB,cAAc;MACd,eAAe;MACf,sBAAsB;MACtB,gCAAgC;AACtC;AACA;MACM,aAAa;MACb,eAAe;MACf,uBAAuB;AAC7B;AACA;MACM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,sBAAsB;MACtB,cAAc;AACpB;AACA;MACM;QACE,UAAU;MACZ;EACJ;;AAEF;MACM,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,iCAAiC;IACnC,wCAAwC;AAC5C;AACA;IACI,yBAAyB;IACzB,WAAW;MACT,iCAAiC;IACnC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;MACV,uBAAuB;MACvB,eAAe;MACf,iBAAiB;MACjB,cAAc;IAChB,8BAA8B;AAClC;AACA;IACI,yBAAyB;IACzB,WAAW;MACT,iCAAiC;AACvC;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;MACV,uBAAuB;MACvB,eAAe;MACf,iBAAiB;MACjB,cAAc;AACpB;AACA;IACI,yBAAyB;IACzB,WAAW;MACT,iCAAiC;IACnC,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA,mBAAmB,yBAAyB;AAC5C,+BAA+B,kCAAkC,CAAC;;AAElE;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iCAAiC;AACnC;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;KACK,sBAAsB;KAGtB,0BAA0B;KAC1B,oCAAoC;KAGpC,qCAAqC;AAC1C;;AAEA,mCAAmC;AASnC;CACC,OACkC,oBAAoB,EACjB,oBAAoB;CACzD,2BAA2B;CAC3B;CACA,OAC+C,oBAAoB,EACjB,oBAAoB;CACtE,wCAAwC;CACxC;AACD;;AAEA;;;;IAII;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;AACtB,EAAE;EACA;IACE,WAAW,EAAE,EAAE;AACnB;IACI,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;AACtB,EAAE;EACA;IACE,WAAW,EAAE,EAAE;AACnB;IACI,WAAW;IACX,SAAS;IAET,+DAA+D;AACnE;;AAEA;IAGI,wBAAwB;IACxB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB,EAAE;EACA;IACE,WAAW,EAAE,EAAE;EACjB;IACE,WAAW;IACX,SAAS;IAET,+DAA+D,EAAE;;AAErE;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,yBAAyB;AAC7B,EAAE;EACA,KAAK,WAAW;EAChB,OAAO,WAAW;AACpB;;AAEA;MACM,aAAa;KACd,gBAAgB;MACf,SAAS;MACT,eAAe;MACf,iBAAiB;MACjB,iCAAiC;IACnC,wCAAwC;AAC5C;AACA;IACI,sBAAsB;IACtB,WAAW;MACT,iCAAiC;AACvC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;IAChB;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;CAEC,2CAA2C;AAC5C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iCAAiC;AACnC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\n\nbody {\n  background: #ccc url(../../public/images/bg.jpg) no-repeat center center fixed;\n  -moz-background-size: cover;\n  -webkit-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  background-attachment: fixed;\n  font-family: \"Inconsolata\", SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 1.9;\n  color: #6c757d;\n}\n::-moz-selection {\n  color: white;\n  background: #6D0000;\n}\n\n::selection {\n  color: white;\n  background: #6D0000;\n}\n\na {\n  -webkit-transition: .3s all ease;\n  -o-transition: .3s all ease;\n  transition: .3s all ease;\n  text-decoration: none;\n  color: #6d0000;  }\n  a:hover {\n    /*text-decoration: none;*/\n    color: #1d0000; }\n\na, button, input {\n  transition: all 0.3s ease;\n}\n  \n\nh1, h2, h3, h4, h5 {\n  color: #000;\n}\n\n.wrap {\n  max-width: 1450px;\n  margin: 0 auto;\n  background: #fff;\n  -webkit-box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.8); \n}\n\nheader {\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 5;\n  font-weight: 400;\n  background: #fff !important; }\n  header .navbar-brand {\n    text-transform: uppercase;\n    letter-spacing: .2em;\n    font-weight: 400;\n    color: #fff !important; }\n  header .navbar-collapse {\n    position: relative; }\n  header .navbar {\n    padding-top: 0;\n    padding-bottom: 0;\n    background: transparent !important; }\n    header .navbar .navbar-nav.absolute-right {\n      position: absolute;\n      right: 0; }\n      @media (max-width: 991.98px) {\n        header .navbar .navbar-nav.absolute-right {\n          position: relative;\n          right: inherit; } }\n    header .navbar .nav-link {\n      padding: 1.7rem 1rem;\n      font-size: 16px;\n      outline: none !important;\n      text-transform: uppercase;\n      letter-spacing: .05em; }\n      @media (max-width: 991.98px) {\n        header .navbar .nav-link {\n          padding: 1.7rem 1rem; } }\n      @media (max-width: 767.98px) {\n        header .navbar .nav-link {\n          padding: .5rem 0rem; } }\n    header .navbar .dropdown-menu {\n      font-size: 14px;\n      border-radius: 0px;\n      border: none;\n      -webkit-box-shadow: 0 2px 30px 0px rgba(0, 0, 0, 0.2);\n      box-shadow: 0 2px 30px 0px rgba(0, 0, 0, 0.2);\n      min-width: 13em;\n      margin-top: -10px; }\n      header .navbar .dropdown-menu:before {\n        bottom: 100%;\n        left: 10%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n        border-bottom-color: #fff;\n        border-width: 10px; }\n        @media (max-width: 1199.98px) {\n          header .navbar .dropdown-menu:before {\n            display: none; } }\n      header .navbar .dropdown-menu .dropdown-item:hover {\n        background: #000;\n        color: #fff; }\n      header .navbar .dropdown-menu .dropdown-item.active {\n        background: #000;\n        color: #fff; }\n      header .navbar .dropdown-menu a {\n        padding-top: 7px;\n        padding-bottom: 7px; }\n\n.absolute-toggle {\n  position: absolute;\n  left: 15px;\n  top: 5px; }\n  .absolute-toggle .burger-lines {\n    width: 30px;\n    display: inline-block;\n    height: 2px;\n    background: #000;\n    position: relative; }\n    .absolute-toggle .burger-lines:before, .absolute-toggle .burger-lines:after {\n      position: absolute;\n      height: 2px;\n      content: \"\";\n      background: #000;\n      width: 100%;\n      left: 0; }\n    .absolute-toggle .burger-lines:before {\n      top: -10px; }\n    .absolute-toggle .burger-lines:after {\n      bottom: -10px; }\n\n.site-logo a {\n  color: #000;\n  font-size: 48px; \n}\n@media (max-width: 767.98px) {\n    .site-logo a {\n        font-size: 34px;\n    }\n}\n\n.top-bar {\n  background: #000;\n  padding: 10px 0;\n}\n  .top-bar .social a, .top-bar .search-icon a {\n    color: #fff;\n    opacity: .5;\n    padding: 5px; }\n    .top-bar .social a:hover, .top-bar .search-icon a:hover {\n      opacity: 1; }\n  .top-bar .social {\n    text-align: left;\n    margin-top: 0.2em\t}\n  .top-bar .search-icon {\n    text-align: right; }\n\n@media (max-width: 575.98px) {\n    .social {\n    text-align:center !important; }\n    .social a {\n    margin-left:0.5em;\n    margin-right:0.5em;\t} \n}\t\n@media (min-width: 576px) and (max-width: 991.98px) {\n    .social {\n    text-align:center !important; }\n    .social a {\n    margin-left:1.5em;\n    margin-right:1.5em;\t} \n}\n    \n.navbar .container\n  @media (max-width: 767.98px) {\n    .navbar .container > div {\n      border-bottom: none; } }\n\n.bio img {\n    border: 2px solid #fff;\n    -webkit-box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.4);\n    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.4);\n    max-width: 100px;\n    /*border-radius: 50%;*/\n    position: relative;\n    margin-bottom: 30px;\n}\n\n.site-section {\n  padding: 1em 0; }\n  .site-section.py-md {\n    padding: 0em 0; }\n  .site-section.py-sm {\n    padding: 0em 0; }\n\n.trades-text {\n    color: #888;\n}\n.trades-id {\n    position: absolute;\n    font-size: 11px;\n    right: 25px;\n    bottom: 25px; \t\n}\n.trades-entry {\n  display: block;\n  -webkit-transition: .3s all ease;\n  -o-transition: .3s all ease;\n  transition: .3s all ease;\n  position: relative;\n  margin-bottom: 20px;\n  padding: 0px 20px 20px 20px;\n  border: 1px solid #efefef;\n}\n  .trades-entry:hover, .trades-entry:focus {\n    opacity: .9;\n    /*-webkit-box-shadow: 0 3px 50px -2px rgba(0, 0, 0, 0.2) !important;\n    box-shadow: 0 3px 50px -2px rgba(0, 0, 0, 0.2) !important; */\n    -webkit-box-shadow: 5px 10px black;\n    box-shadow: 5px 10px black;}\n  .trades-entry h2 {\n    font-size: 18px;\n    line-height: 1.5; }\n  .trades-entry p {\n    font-size: 13px;\n    color: gray; }\n.trades-title {\n    color: black;\n    font-size: 1.3rem !important;\n    display: inline;\n}\n.trades-img {\n    height: 2rem;\n    display: inline;\n    margin-bottom: 0.5rem;\n    padding-right: 0.5rem;\n}\n.trades-content-body {\n    background-position: right 1rem top 3rem !important;\n}\n\n.post-meta {\n  font-size: 14px;\n  color: #888; }\n  .trades-entries .post-meta .author img {\n    width: 30px;\n    border-radius: 50%;\n    display: inline-block; }\n.stats-post-meta {\n    display: inline;\n    font-size: 14px;\n    color: #888;\n    margin-left: 2rem;\t\n}\n    \n.closed_green {\n  font-size: 18px;\n  color: #4bb820;\n  float: right;  }\n.closed_red {\n  font-size: 18px;\n  color: #b82020;\n  float: right;  }\n.open_position {\n  font-size: 18px;\n  color: #888;\n  float: right;  }\n.stats_green {\n  color: #4bb820;\n}\n.stats_red {\n  color: #b82020;\n}\n\n.flaticon-custom {\n  font-size: 70px; }\n  .flaticon-custom:before, .flaticon-custom:after {\n    margin-left: 0; }\n\n.no-nav .owl-nav {\n  display: none; }\n\nblockquote {\n  padding-left: 30px;\n  border-left: 10px solid #e6e6e6; }\n  blockquote p {\n    font-size: 18px;\n    font-style: italic;\n    color: #000; }\n\n.list-unstyled.check li {\n  position: relative;\n  padding-left: 30px;\n  line-height: 1.3;\n  margin-bottom: 10px; }\n  .list-unstyled.check li:before {\n    color: #17a2b8;\n    left: 0;\n    font-family: \"Ionicons\";\n    content: \"\\f122\";\n    position: absolute; }\n\n#modalAppointment .modal-content {\n  border-radius: 0;\n  border: none; }\n\n#modalAppointment .modal-body, #modalAppointment .modal-footer {\n  padding: 40px; }\n\n.overflow {\n  position: relative;\n  overflow-x: hidden; }\n\n.site-footer {\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  padding: 1em 0;\n  background: #000; }\n  .site-footer .post-entry-sidebar ul li a h4 {\n    color: #fff; }\n  .site-footer .footer-social li a > span {\n    width: 30px; }\n  .site-footer a {\n    color: #fff; }\n    .site-footer a:hover {\n      opacity: .5; }\n  .site-footer h3 {\n    color: #fff;\n    margin-bottom: 30px;\n    font-size: 14px;\n    text-transform: uppercase;\n    letter-spacing: .2em; }\n  .site-footer p {\n    color: rgba(255, 255, 255, 0.5); }\n\n.analysis-entry-footer .post-meta {\n  color: white;\n  font-size: 15px; }\n\n.border-t {\n  border-top: 1px solid #f8f9fa; }\n\n.copyright {\n  font-size: 14px; }\n\n.element-animate {\n  opacity: 0;\n  visibility: hidden; }\n  \n#loader {\n  position: fixed;\n  width: 96px;\n  height: 96px;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  background-color: rgba(255, 255, 255, 0.9);\n  -webkit-box-shadow: 0px 24px 64px rgba(0, 0, 0, 0.24);\n  box-shadow: 0px 24px 64px rgba(0, 0, 0, 0.24);\n  border-radius: 16px;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: opacity .2s ease-out, visibility 0s linear .2s;\n  -o-transition: opacity .2s ease-out, visibility 0s linear .2s;\n  transition: opacity .2s ease-out, visibility 0s linear .2s;\n  z-index: 1000;\n}\n\n#loader.fullscreen {\n  padding: 0;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-transform: none;\n  -ms-transform: none;\n  transform: none;\n  background-color: #fff;\n  border-radius: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n#loader.show {\n  -webkit-transition: opacity .4s ease-out, visibility 0s linear 0s;\n  -o-transition: opacity .4s ease-out, visibility 0s linear 0s;\n  transition: opacity .4s ease-out, visibility 0s linear 0s;\n  visibility: visible;\n  opacity: 1;\n}\n\n#loader .circular {\n  -webkit-animation: loader-rotate 2s linear infinite;\n  animation: loader-rotate 2s linear infinite;\n  position: absolute;\n  left: calc(50% - 24px);\n  top: calc(50% - 24px);\n  display: block;\n  -webkit-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n\n#loader .path {\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  -webkit-animation: loader-dash 1.5s ease-in-out infinite;\n  animation: loader-dash 1.5s ease-in-out infinite;\n  stroke-linecap: round;\n}\n\n@-webkit-keyframes loader-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); }\n}\n\n@keyframes loader-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); }\n}\n\n@-webkit-keyframes loader-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -136px; }\n}\n\n@keyframes loader-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -136px; }\n}\n\n@-webkit-keyframes loader-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes loader-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -136px; } }\n\n@keyframes loader-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -136px; } }\n    \n.login {\n    width: 400px;\n    background-color: #ffffff;\n      box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);\n      margin: 0px auto;\n}\n@media (max-width: 767.98px) {\n      .login {\n        width: 90%;\n      }\n  }\n  \n.login h1 {\n      text-align: center;\n      color: #5b6574;\n      font-size: 24px;\n      padding: 20px 0 20px 0;\n      border-bottom: 1px solid #dee0e4;\n}\n.login form {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      padding-top: 20px;\n}\n.login form label {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 50px;\n      height: 50px;\n      background-color: #000;\n      color: #ffffff;\n}\n@media (max-width: 767.98px) {\n      .login form label {\n        width: 90%;\n      }\n  }\n\n.login form input[type=\"password\"], .login form input[type=\"text\"] {\n      width: 310px;\n      height: 50px;\n      border: 1px solid #dee0e4;\n      margin-bottom: 20px;\n      padding: 0 15px;\n}\n@media (max-width: 767.98px) {\n      .login form input[type=\"password\"], .login form input[type=\"text\"] {\n        width: 90%;\n      }\n  }\n\n.login form input[type=\"submit\"] {\n      width: 100%;\n      padding: 15px;\n     margin-top: 20px;\n      background-color: #000;\n      border: 0;\n      cursor: pointer;\n      font-weight: bold;\n      color: #ffffff;\n      transition: background-color 0.2s;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);\n}\n.login form input[type=\"submit\"]:hover {\n    background-color: #ffffff;\n    color: #000;\n      transition: background-color 0.2s;\n    border-inline: 1px solid black;\n}\n\n.logout {\n    width: 200px;\n    background-color: #ffffff;\n      box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);\n      margin: 0px auto;\n}\n@media (max-width: 767.98px) {\n      .logout {\n        width: 90%;\n      }\n  }\n  \n.logout h1 {\n      text-align: center;\n      color: #5b6574;\n      font-size: 24px;\n      padding: 20px 0 20px 0;\n      border-bottom: 1px solid #dee0e4;\n}\n.logout form {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n}\n.logout form label {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 50px;\n      height: 50px;\n      background-color: #000;\n      color: #ffffff;\n}\n@media (max-width: 767.98px) {\n      .logout form label {\n        width: 90%;\n      }\n  }\n\n.logout form input[type=\"submit\"] {\n      width: 100%;\n      padding: 15px;\n      background-color: #000;\n      border: 0;\n      cursor: pointer;\n      font-weight: bold;\n      color: #ffffff;\n      transition: background-color 0.2s;\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);\n}\n.logout form input[type=\"submit\"]:hover {\n    background-color: #ffffff;\n    color: #000;\n      transition: background-color 0.2s;\n    border-inline: 1px solid black;\n}\n\nform input, form button {\n    width: 100%;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\t\n}\n.social_post {\n    width: 50% !important;\n    float:left;\n}\n.trade_post {\n    width: 33% !important;\n    float:left;\n}\n\n.seperate {\n    width: 100%;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\t\n}\n.seperate-save {\n    width: 100%;\n    background-color: #000;\n    padding: 5px;\n      border: 1px solid black;\n      cursor: pointer;\n      font-weight: bold;\n      color: #ffffff;\n    border-inline: 1px solid black;\n}\n.seperate-save:hover {\n    background-color: #ffffff;\n    color: #000;\n      transition: background-color 0.2s;\n}\n.seperate-mid {\n    width: 50%;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    float: left;\n}\n.seperate-short {\n    width: 33%;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    float: left;\n}\n.seperate-longtext {\n    width: inherit;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\t\n}\n.save, .delete, .update {\n    width: 100%;\n    background-color: #000;\n    padding: 5px;\n      border: 1px solid black;\n      cursor: pointer;\n      font-weight: bold;\n      color: #ffffff;\n}\n.save:hover, .delete:hover, .update:hover {\n    background-color: #ffffff;\n    color: #000;\n      transition: background-color 0.2s;\n    border-inline: 1px solid black;\n}\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    border: 1px solid #ddd;\n}\nth, td {\n    text-align: left;\n    padding: 5px;\n}\ntr:nth-child(even){background-color: #f2f2f2}\n.marketcap tr:nth-child(even) {background-color: white !Important;}\n\n.marketcap {\n    font-size: 16px;\n}\n\n.chart-container {\n    width: 100%;\n    height: auto;\n}\n.pie-chart-container {\n    width: 360px;\n    height: 360px;\n    float: left;\n}\n\n.archive {\n    margin-left: auto !important;\n    margin-right: auto !important;\n}\n.archive_sitenr {\n    padding-right: 2rem;\n    padding-left: 2rem;\n}\n\n.archive_sitenr:hover {\n  background-color: #fff;\n  color: #000;\n  transition: background-color 0.2s;\n}\n\n.cryptoslider-box {\n    height:40px !important; \n    background-color: #FFFFFF !important; \n    border-radius: 4px; \n}\n\n.cryptoslider {\n    overflow: hidden;\n    white-space: nowrap;\n    position: relative;\n}\n\n.cryptoslider img {\n    height: 25px;\n}\n\n.cryptoslide-unit {\n     /* Starting position */\n     -moz-transform:translateX(100%);\n     -webkit-transform:translateX(100%);\n     transform:translateX(100%);\n     /* Apply animation to this element */\n     -moz-animation: scroll 50s linear infinite;\n     -webkit-animation: scroll 50s linear infinite;\n     animation: scroll 50s linear infinite;\n}\n\n/* Move it (define the animation) */\n@-moz-keyframes scroll {\n 0%   { -moz-transform: translateX(100%); }\n 100% { -moz-transform: translateX(calc(-210px * 15)); }\n}\n@-webkit-keyframes scroll {\n 0%   { -webkit-transform: translateX(100%); }\n 100% { -webkit-transform: translateX(calc(-210px * 15)); }\n}\n@keyframes scroll {\n 0%   { \n -moz-transform: translateX(100%); /* Firefox bug fix */\n -webkit-transform: translateX(100%); /* Firefox bug fix */\n transform: translateX(100%); \n }\n 100% { \n -moz-transform: translateX(calc(-210px * 15)); /* Firefox bug fix */\n -webkit-transform: translateX(calc(-210px * 15)); /* Firefox bug fix */\n transform: translateX(calc(-210px * 15)); \n }\n}\n\n.cryptoslide:hover,\n.cryptoslide-unit:hover,\n.cryptoslider:hover,\n.cryptoslider-box:hover {\n    animation-play-state: paused\n}\n\n.cryptoslider h5 {\n    margin-top: 0.35em;\n}\n\n.cryptoslider object {\n    width: 15px;\n    height: 15px;\n}\n\n#searchbar, #searchbar_trade, #searchbar_analysis {\n    width: 100%;\n}\n\ninput#searchbar, input#searchbar_trade, input#searchbar_analysis {\n    width: 100%;\n}\n\n.crypto-right {\n    text-align: right;\n}\n.crypto-logo-left {\n    float: left;\n    margin: 10px 25px 10px 0px;\n    width: 100px;\n    position: relative;\n} @media (max-width: 767.98px) {\n  .crypto-logo-left {\n    width: 60px; } }\n.crypto-logo-right {\n    float: right;\n    margin: 10px 0px 10px 25px;\n    width: 100px;\n    position: relative;\n} @media (max-width: 767.98px) {\n  .crypto-logo-right {\n    width: 60px; } }\n.crypto-logo-left:hover, .crypto-logo-left:focus, .crypto-logo-right:hover, .crypto-logo-right:focus {\n    opacity: .9;\n    top: -1px;\n    -webkit-box-shadow: 0 3px 50px -2px rgba(255, 252, 255, 0.2) !important;\n    box-shadow: 0 3px 50px -2px rgba(255, 252, 255, 0.2) !important; \n}\n\n.investment-logo {\n    -webkit-transition: .3s all ease;\n    -o-transition: .3s all ease;\n    transition: .3s all ease;\n    float: left;\n    margin: 10px 10px;\n    width: 140px;\n    position: relative;\n} @media (max-width: 767.98px) {\n  .investment-logo {\n    width: 60px; } }\n  .investment-logo:hover, .investment-logo:focus {\n    opacity: .9;\n    top: -1px;\n    -webkit-box-shadow: 0 3px 50px -2px rgba(255, 252, 255, 0.2) !important;\n    box-shadow: 0 3px 50px -2px rgba(255, 252, 255, 0.2) !important; }\n    \n.popover {\n    max-width: 100%;\n}\n\n.form-control:focus {\n    border-color: black;\n    box-shadow: 0 0 0 .2rem rgba(0,0,0,.25);\n}\n\n.token_market {\n    overflow-x: auto;\n    opacity: 1;\n    animation: fade 2s linear;\n} @keyframes fade {\n  0% { opacity: 0 }\n  100% { opacity: 1 }\n}\n\n.trade {\n      padding: 15px;\n     margin-top: 10px;\n      border: 0;\n      cursor: pointer;\n      font-weight: bold;\n      transition: background-color 0.2s;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);\n}\n.trade:hover {\n    background-color: #000;\n    color: #fff;\n      transition: background-color 0.2s;\n}\n\n.mobile_table {\n    overflow-x: auto;\n}\n.mobile_table img {\n    height: 40px;\n}\n@media (max-width: 575.98px) {\n    .mobile_table {\n        font-size: 10px !important;\n    }\n    .mobile_table img {\n        height: 20px;\n    }\n    .mobile_table th, .mobile_table td {\n        padding: 1px !important;\n    }\n}\n@media (min-width: 576px) and (max-width: 991.98px) {\n    .mobile_table {\n        font-size: 14px !important;\n    }\n    .mobile_table img {\n        height: 30px;\n    }\n}\n\n.btn:focus {\n    outline: none !important;\n}\n\n@media (max-width: 767.98px) {\n    .token_contract {\n        font-size: 15px;\n    }\n}\n\n /* The switch - the box around the slider */\n.switch {\n  position: relative;\n  display: inline-flex;\n  width: 30px;\n  height: 17px;\n  bottom: 2px\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* The slider */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 13px;\n  width: 13px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: #6d0000;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #6d0000;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(13px);\n  -ms-transform: translateX(13px);\n  transform: translateX(13px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 17px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n#sideshift-modal-button {\n  -webkit-appearance: none;\n  background: #1f1f1f;\n  color: #fff;\n  cursor: pointer;\n  border: 0;\n  margin: 0 auto 1rem auto;\n  min-width: 10rem;\n  position: relative;\n  z-index: 2;\n  font-weight: bold;\n  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);\n}\n\n#sideshift-modal-button:hover {\n  background-color: #fff;\n  color: #000;\n  transition: background-color 0.2s;\n}\n\n.gobackhome {\n    overflow: hidden;\n    padding: 10px 3px;\n\n}\n\n.qr {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.crop {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n#scrollbacktop {\n  -webkit-appearance: none;\n  background: #fff;\n  color: #000;\n  cursor: pointer;\n  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.3);\n  display: none;\n  position: fixed;\n  bottom: 20px;\n  right: 30px;\n  z-index: 99;\n  border: none;\n  outline: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n}\n\n#scrollbacktop:hover {\n  background-color: #1f1f1f;\n  color: #fff;\n  transition: background-color 0.2s;\n}\n\n.qr-container {\n  background: white;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n.popover {\n  max-width: 300px;\n}\n\n.qr-wrapper svg {\n  display: block;\n}\n\n.btn-link.qr {\n  color: inherit;\n}\n\n.btn-link.qr:hover {\n  opacity: 0.8;\n}\n\n@media (max-width: 767.98px) {\n  body {\n    font-size: 14px;\n    line-height: 1.7;\n  }\n  \n  .trades-title {\n    font-size: 1.1rem !important;\n  }\n  \n  .trades-text, .post-meta {\n    font-size: 12px;\n  }\n  \n  .closed_green, .closed_red, .open_position {\n    font-size: 16px;\n  }\n  \n  .trades-id {\n    font-size: 10px;\n  }\n  \n  blockquote p {\n    font-size: 14px;\n  }\n  \n  .marketcap {\n    font-size: 14px;\n  }\n  \n  .cryptoslider h5 {\n    font-size: 14px;\n    margin-top: 0.25em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
